module.exports = __webpack_public_path__ + "img/mine_icon_header_girl.ea34da11.png";